export default "__VITE_ASSET__a016b6c7__"